import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { Filter, FilterParameterType } from './filter-element/filter.element.component';

@Component({
  standalone: false,
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {
  @Input()
  filter!: Filter;

  @Input()
  buttonText: string = 'Filter';

  @Output()
  applyFilterEvent = new EventEmitter();

  @Output()
  clearFilterEvent = new EventEmitter();

  isFilterOpened: boolean = false;

  public get isFilterActive(): boolean {
    return !Filter.isFilterEmpty(this.filter);
  }

  @ViewChild('toggleButton')
  toggleButton!: ElementRef;

  @ViewChild('filterDropdown')
  filterDropdown!: ElementRef;

  @ViewChild('caret')
  caretSpan!: ElementRef;

  constructor(private renderer: Renderer2) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (e.target !== this.toggleButton.nativeElement
        && e.target !== this.caretSpan.nativeElement
        && !this.isClickedInsideFilter(e)) {
        this.isFilterOpened = false;
      }
    });
  }

  onFilterClick($event: any): void {
    this.isFilterOpened = !this.isFilterOpened;
  }

  onClearClick(): void {
    Filter.clear(this.filter);
    this.clearFilterEvent.emit('');
  }

  onDoneClick(): void {
    this.isFilterOpened = false;

    const dateRangeParameters = this.filter.parameters.filter(
      x => x.type === FilterParameterType.dateRange && x.isActive
    );

    dateRangeParameters.forEach(parameter => {
      if (!parameter.values ||
        parameter.values.length !== 2 ||
        parameter.values[1] == undefined) {
        return;
      }

      let toDate = new Date(parameter.values[1]);
      toDate.setHours(23, 59, 59, 999);
      if (parameter.values[1] instanceof Date) {
        parameter.values[1] = toDate;
      } else {
        parameter.values[1] = toDate.toISOString();
      }
    });

    this.applyFilterEvent.emit('');
  }

  private isClickedInsideFilter(event: any): boolean {
    if (this.filterDropdown) {
      const rect = this.filterDropdown.nativeElement.getBoundingClientRect();
      if ((event.x >= rect.x && event.x <= rect.x + rect.width) &&
        (event.y >= rect.y && event.y <= rect.y + rect.height)) {
        return true;
      }
    }
    return false;
  }
}
